import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/smanga-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-37dfd6fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "seat" }, null, -1 /* HOISTED */))
const _hoisted_2 = { class: "login-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "logo"
  })
], -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "app-box" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/file/smanga1.1.apk" }, "下载Android应用")
], -1 /* HOISTED */))
const _hoisted_5 = { class: "btn-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['login-index', _ctx.backClass])
  }, [
    _hoisted_1,
    _createCommentVNode(" 登录面板 "),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_form, {
        class: "login-form",
        ref: "form",
        model: _ctx.form,
        "label-width": "80px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "用户名:" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.userName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.userName) = $event)),
                placeholder: "请输入用户名"
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, { label: "密码:" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.passWord,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.passWord) = $event)),
                placeholder: "请输入内容"
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["model"]),
      _hoisted_4,
      _createCommentVNode("按钮盒子"),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          class: "login-btn",
          type: "primary",
          onClick: _ctx.do_login
        }, {
          default: _withCtx(() => [
            _createTextVNode("登录")
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"])
      ])
    ])
  ], 2 /* CLASS */))
}